export const fetchTokenClaims = (token) => {
    if (token != null) {
        let token_parts = token.split('.');
        let b64Claims = token_parts[1];
        let b64Buff = new Buffer(b64Claims, 'base64');
        let plainClaims = b64Buff.toString('ascii');
        return JSON.parse(plainClaims);
    } else {
        return null;
    }
}

export const isTokenValid = (token) => {
    if (token != null) {
        let token_exp = new Date(token.exp * 1000);
        let now = new Date();
        if (token_exp.getTime() > now.getTime()) {
            return true;
        }
        else {
            return false;
        }
    } else {
        return
    }

}


export const expiresAt = (token) => {
    if (token != null) {
        let tokenExpTime = new Date(token.exp * 1000);
        let now = new Date();
        let milliSeconds = (tokenExpTime.getTime() - now.getTime()) - 600000; //TODO : expires before 10 minutes
        return milliSeconds;
    } else {
        return 3600000;
    }

}


